const Machinata = require("./lib/machinata-core-bundle-reactjs.js");
require("./lib/machinata-reporting-bundle-reactjs.js");

module.exports = Machinata;
